import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import {
  FiUser,
  FiMapPin,
  FiBell,
  FiLock,
  FiTrash2,
  FiCreditCard,
} from "react-icons/fi";
import { FaChild, FaEnvelope } from "react-icons/fa";
import Modal from "../../common/Modal";
import { useToast } from "../../contexts/ToastContext";
import { IoAtSharp } from "react-icons/io5";
const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.09, duration: 0.2, ease: "easeOut" },
  }),
};
const profileOptions = [
  {
    id: 1,
    title: "Edit Personal Info",
    icon: <FiUser size={24} />,
    path: "/account/profile/personal-info",
  },
  {
    id: 2,
    title: "Edit Child Info",
    icon: <FaChild size={24} />,
    path: "/account/profile/child-info",
  },
  {
    id: 3,
    title: "Address Management",
    icon: <FiMapPin size={24} />,
    path: "/account/profile/address-management",
  },
  // {
  //   id: 4,
  //   title: "Saved Cards Management",
  //   icon: <FiCreditCard size={24} />,
  //   path: "/account/profile/payment-cards",
  // },
  {
    id: 5,
    title: "Change Password",
    icon: <FiLock size={24} />,
    path: "/account/profile/change-password",
  },
  {
    id: 6,
    title: "Change Email",
    icon: <IoAtSharp size={24} />,
    path: "/account/profile/change-email",
  },
  // {
  //   id: 6,
  //   title: "Delete Account",
  //   icon: <FiTrash2 size={24} />,
  //   path: null, // no path, will open modal
  // },
];

const AllProfileOptions = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const { addToast } = useToast();
  const handleOptionClick = (option) => {
    if (option.title === "Delete Account") {
      setShowModal(true);
    } else if (option.path) {
      navigate(option.path);
    }
  };

  const handleClose = () => setShowModal(false);
  const handleConfirmDelete = () => {
    // TODO: call delete API here
    addToast("Account deleted!", "success");
    setShowModal(false);
    navigate("/");
  };

  return (
    <>
      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
        {profileOptions.map((option, i) => (
          <motion.div
            key={option.id}
            custom={i}
            variants={cardVariants}
            initial="hidden"
            animate="visible"
            whileHover={{
              boxShadow: "0px 8px 18px rgba(0,0,0,0.1)",
            }}
            whileTap={{ scale: 0.97 }}
            onClick={() => handleOptionClick(option)}
            className="cursor-pointer p-6 bg-[#DEE2DD]/40 rounded-[15px] shadow flex items-center gap-4 font-medium text-gray-800 hover:bg-gray-100 transition-colors"
          >
            <div className="text-green">{option.icon}</div>
            <span className="text-lg">{option.title}</span>
          </motion.div>
        ))}
      </div>

      {/* Delete Account Modal */}
      <Modal
        isOpen={showModal}
        onClose={handleClose}
        title="Delete Account"
        onConfirm={handleConfirmDelete}
      >
        <div className="font-mono">
          <p className="text-gray-800">
            Are you sure you want to delete your account? This action is{" "}
            <span className="">permanent</span> and cannot be undone.
          </p>
          <p className="text-gray-700 mt-3">
            Once you delete your account, all your personal information,meal
            subscriptions, child profiles, saved addresses, payment methods, and
            order history will be <span className="">permanently removed</span>.
          </p>
          <p className="text-gray-700 mt-3">
            If you are certain about deleting your account, please click{" "}
            <span className="">Delete</span>. Otherwise, you can cancel and
            retain your account.
          </p>
        </div>
      </Modal>
    </>
  );
};

export default AllProfileOptions;
